import {Component, OnInit} from '@angular/core';
import {GridApi, GridOptions, IDatasource, IGetRowsParams} from 'ag-grid-community';
import {User} from '../../services/user/user';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {FrtRateDownloadService} from '../frt-rates-download/frt-rate-download.service';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {api_error, frt_acc_download_success} from '../../shared/common-components/AppConstants';
import {DownloadFileResponse} from '../../shared/common-components/file-storage/downloadFileResponse';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-frt-accesorials-table',
    templateUrl: './frt-accesorials-table.component.html',
    styleUrls: ['./frt-accesorials-table.component.css'],
    standalone: false
})
export class FrtAccesorialsTableComponent implements OnInit {
  /**
   * The gridOptions is a 'one stop shop' for the entire interface into the grid. The grid options can be used regardless of the framework you are using, however if you are using a framework,
   * you can additionally achieve what grid options provides with your frameworks bindings. How to configure for the particular framework is explained further down this page.
   * we are using infinite row model which will call server to get data every time page changes
   */
  gridOptions: GridOptions = {
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSize: 50,
    cacheBlockSize: 50,
    headerHeight: 50
  };
  // params from modal initial state
  sroMasterId: any;
  carrierId: any;
  ratesBidcyclesId: number;

  public overlayLoadingTemplate;
  public overlayNoRowsTemplate;
  public domLayout;
  currentUser: User | any;
  public modalRef: BsModalRef;
  private gridApi!: GridApi<any>;
  public columnDefsAcc;
  paramsObj: any;
  showExport = false;
  public components;
  public defaultColDef;
  public rowSelection;
  public rowModelType;
  public paginationPageSize;
  public cacheOverflowSize;
  public maxConcurrentDatasourceRequests;
  public infiniteInitialRowCount;
  public maxBlocksInCache;
  public getRowNodeId;
  public cacheBlockSize;
  /**
   *  Setting new datasource into the grid. The grid will reset all paging and load the first page. If you want to reset the paging but keep the datasource, call this method with the same datasource.
   */
  dataSource: IDatasource = {
    getRows: (params: IGetRowsParams) => {
      const paramsObj = FrtAccesorialsTableComponent.getFilterModal(params.filterModel, params.sortModel);
      this.paramsObj = paramsObj;
      if (this.carrierId !== null && this.carrierId !== undefined && this.sroMasterId !== undefined && this.sroMasterId !== null) {
        this.gridApi.showLoadingOverlay();
        this.frtrateDownload.getRowDataForACCWithPage(this.sroMasterId, this.gridApi.paginationGetCurrentPage(), this.gridOptions.paginationPageSize, this.carrierId, paramsObj, this.ratesBidcyclesId).subscribe((data: any) => {
          const endParam = this.gridOptions.cacheBlockSize;
          setTimeout(() =>  {
            const dataAfterSortingAndFiltering = sortAndFilter(data.content, params.sortModel, params.filterModel);
            const rowsThisPage = dataAfterSortingAndFiltering.slice(0, endParam);
            params.successCallback(
                rowsThisPage,
                data.totalElements
            );
          }, 500);
          this.gridApi.hideOverlay();
          this.showExport = true;
          if (data.content.length === 0) {
            this.gridApi.showNoRowsOverlay();
            this.showExport = false;
          } else {
            this.showExport = true;
            this.gridApi.hideOverlay();
          }
        }, error => {
          this.alertService.info('No results found. Please adjust your filters.');
          this.gridApi.hideOverlay();
          this.showExport = false;
        });
      }
    }
  };

  /**
   * getting the filter and sort params
   * @param:: filterParam
   * @param:: sortParam
   */
  static getFilterModal(filterParam, sortParam) {
    const paramsObj = [];
    if (filterParam !== null && filterParam !== undefined) {
      if (filterParam.sro) {
        paramsObj.push({name: 'sro', value: filterParam.sro.filter});
      } else {
        paramsObj.push({name: 'sro', value: 'none'});
      }
      if (filterParam.rateAmount) {
        paramsObj.push({name: 'rateAmount', value: filterParam.rateAmount.filter});
      } else {
        paramsObj.push({name: 'rateAmount', value: 'none'});
      }
      if (filterParam.minimumCharge) {
        paramsObj.push({name: 'minimumCharge', value: filterParam.minimumCharge.filter});
      } else {
        paramsObj.push({name: 'minimumCharge', value: 'none'});
      }
    }

    if (sortParam !== null && sortParam !== undefined && sortParam.length > 0) {
      if (sortParam[0].colId && sortParam[0].sort) {
        paramsObj.push({name: 'orderByClause', value: sortParam[0].colId + '_' + sortParam[0].sort});
      } else {
        paramsObj.push({name: 'orderByClause', value: 'none'});
      }
    } else {
      paramsObj.push({name: 'orderByClause', value: 'none'});
    }

    if (paramsObj.length === 0) {
      paramsObj.push({name: 'sro', value: 'none'});
      paramsObj.push({name: 'rateAmount', value: 'none'});
      paramsObj.push({name: 'minimumCharge', value: 'none'});
      paramsObj.push({name: 'orderByClause', value: 'none'});
    }
    return paramsObj;
  }

  /**
   * @description defines ag-grid components and options
   * @param: {FrtRateDownloadService} frtrateDownload
   * @param: {LoadingService} tmssloader
   * @param: {AlertService} alertService
   * @param: {BsModalService} modalService
   * @param: {BsModalRef} bsModalRef
   */
  constructor(private frtrateDownload: FrtRateDownloadService, private tmssloader: LoadingService, private alertService: AlertService, private modalService: BsModalService, private bsModalRef: BsModalRef) {
    this.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
    this.overlayNoRowsTemplate = '<span style="margin: 27px 53px 0 0;">No results found. Please adjust your filters.</span>';
    this.columnDefsAcc = [

      {
        headerName: 'BIDCYCLE NAME',
        field: 'bidCycleName'
      },
      {
        headerName: 'SRO',
        field: 'sro'
      },
      {
        headerName: 'TSP',
        field: 'tsp'
      },
      {
        headerName: 'TARIFF CHARGECODE',
        field: 'accessorialsCode'
      },
      {
        headerName: 'CHARGECODE DESCRIPTION',
        field: 'chargeCodeDescription'
      },
      {
        headerName: 'RANGE FROM',
        field: 'rangeFrom'
      },
      {
        headerName: 'RANGE TO UNITS',
        field: 'rangeToUnits'
      },
      {
        headerName: 'RATE AMOUNT',
        field: 'rateAmount'
      },
      {
        headerName: 'MINIMUM CHARGE',
        field: 'minimumCharge'
      }];
    this.components = {
      loadingRenderer: function (params) {
        if (params.value !== undefined) {
          return params.value;
        } else {
          return '<img src="../images/loading.gif">';
        }
      }
    };
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      autoHeight: true,
      suppressDragLeaveHidesColumns: true,
      filterParams: {
        suppressAndOrCondition: true
      }
    };
    this.rowSelection = 'multiple';
    this.rowModelType = 'infinite';
    this.cacheOverflowSize = 2;
    this.maxConcurrentDatasourceRequests = 2;
    this.infiniteInitialRowCount = 1;
    this.maxBlocksInCache = 2;
    this.paginationPageSize = 50;
    this.cacheBlockSize = 50;
    this.getRowNodeId = function (item) {
      return item.id;
    };

    this.domLayout = 'autoHeight';
  }

  ngOnInit() {
  }

  /**
   * @description closes the modal, using this method as bsModalRef is private to the component class.
   */
  closeModal() {
    this.bsModalRef.hide();
  }

  /**
   * Exporting the data in the csv format
   */
  onBtExport() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'The current FRT Accessorials rates download file contains data from the table view only, if you need all data with filters, please click option No-';
    this.modalRef.content.title = 'Do you want to download rates from the table view ?';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No - download all rates with filters';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        const date = new Date();
        const params = {
          fileName: 'frt-acc-rates-report-' + date + '.csv',
          allColumns: true,
          columnSeparator: ','
        };
        this.gridApi.exportDataAsCsv(params);
        this.showExport = false;
        setTimeout(() => {
          this.showExport = true;
        }, 5200);
      } else if (result.obj === false) {
        let frtrRatesResult: DownloadFileResponse;
        this.tmssloader.show();
        this.frtrateDownload.exportDataForAccFromServer(this.sroMasterId, this.carrierId, this.paramsObj, this.ratesBidcyclesId).subscribe((data: any) => {
          frtrRatesResult = data as DownloadFileResponse;
          const byteData: number[] = frtrRatesResult.byteData;
          const fileName: string = frtrRatesResult.fileName;
          const numRows: number = frtrRatesResult.numberOfExcelRows;
          const bytes = new Uint8Array(byteData);
          const blob = new Blob([bytes], {
            type: null
          });
          FileSaver.saveAs(blob, fileName);
          this.alertService.success(frt_acc_download_success);
          this.showExport = false;
          this.tmssloader.hide();

          setTimeout(() => {
            this.showExport = true;
          }, 5200);
        }, error => {
          this.alertService.error(api_error);
          this.tmssloader.hide();
        });
      }
    });

  }


  /**
   * initializing the ag-grid
   * @param:: params
   */
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    params.api.resetRowHeights();
    this.gridApi = params.api;
    this.gridApi.setGridOption('datasource', this.dataSource);
  }

}

/**
 * @param:: allOfTheData
 * @param:: sortModel
 * @param:: filterModel
 */
function sortAndFilter(allOfTheData, sortModel, filterModel) {
  return sortData(sortModel, filterData(filterModel, allOfTheData));
}

/**
 * sorting the data
 * @param:: sortModel
 * @param:: data
 */
function sortData(sortModel, data) {
  const sortPresent = sortModel && sortModel.length > 0;
  if (!sortPresent) {
    return data;
  }
  const resultOfSort = data.slice();
  resultOfSort.sort(function (a, b) {
    for (let k = 0; k < sortModel.length; k++) {
      const sortColModel = sortModel[k];
      const valueA = a[sortColModel.colId];
      const valueB = b[sortColModel.colId];
      if (valueA === valueB) {
        continue;
      }
      const sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
      if (valueA > valueB) {
        return sortDirection;
      } else {
        return sortDirection * -1;
      }
    }
    return 0;
  });
  return resultOfSort;
}

/**
 * filtering the data
 * @param:: filterModel
 * @param:: data
 */
function filterData(filterModel, data) {
  const filterPresent = filterModel && Object.keys(filterModel).length > 0;
  if (!filterPresent) {
    return data;
  }
  const resultOfFilter = [];
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (filterModel.sro) {
      if (filterModel.sro.filter.toUpperCase().indexOf(item.sro.toString().toUpperCase()) < 0) {
        continue;
      }
    }
    resultOfFilter.push(item);
  }
  return resultOfFilter;
}

